// src/redux/reducers/webappLayoutReducer.ts
import { createReducer } from "@reduxjs/toolkit";
import { setHeaderHeight } from "../actions/webappLayoutAction";

const initialState = {
    headerHeight: 0 as number | undefined,
};

export const webappReducer = createReducer(initialState, (builder) => {
    builder.addCase(setHeaderHeight, (state, action) => {
        state.headerHeight = action.payload;
    });
});
